import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { useNavigate, } from 'react-router-dom';

import UpgradeWalletHistory from './upgradeWalletHistory';
import TopUpIncomeHistory from './topupIncome';
import { useUserUpgradeHistory } from './api/upgradeApi';
import AdminTopUp from './adminTopup';
import Loader from '../Loader/buttonLoad';

const UpgradeTab = () => {
    const [activeTab, setActiveTab] = useState('income');


    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { data: userHistory, isLoading: userHistoryLoading } = useUserUpgradeHistory({
        page,
        size: rowsPerPage,
        type: activeTab
    })





    const navigate = useNavigate()
    const toggle = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab)
             setPage(0);
        }

    }


    return (


        <>
            {userHistoryLoading && <Loader />}
            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/upgrade-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Upgrade Wallet History</span>
                        </div>

                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <Nav pills className='mypillsTabs'>
                                        <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'income' })}
                                                    onClick={() => { toggle('income'); }}
                                                >
                                                    Top-Up Income
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'user' })}
                                                    onClick={() => { toggle('user'); }}
                                                >
                                                    Top-up Level Out
                                                </NavLink>
                                            </NavItem>    
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === 'admin' })}
                                                    onClick={() => { toggle('admin'); }}
                                                >
                                                    Missed Payout
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <div className="tabcnt">
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="user">
                                                <UpgradeWalletHistory userHistory={userHistory} page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} />
                                            </TabPane>

                                        </TabContent>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="income">
                                                <TopUpIncomeHistory />
                                            </TabPane>

                                        </TabContent>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="admin">
                                                <AdminTopUp userHistory={userHistory} page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} />
                                            </TabPane>

                                        </TabContent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpgradeTab;